import { render, staticRenderFns } from "./PaymentTypeList.vue?vue&type=template&id=3be64e72"
import script from "./PaymentTypeList.vue?vue&type=script&lang=js"
export * from "./PaymentTypeList.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypeList.vue?vue&type=style&index=0&id=3be64e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports